import React from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import { PolygonLayerFeatureProperties } from 'components/InteractiveMap/PolygonLayer';
import { ModelPerformanceLegendItem } from 'types/Meteorology/Fields/ModelPerformance/mapData';

import './index.scss';

export interface DetailSheetProps {
  open: boolean;
  dismiss: () => void;
  feature: PolygonLayerFeatureProperties | null;
  legend: ModelPerformanceLegendItem[];
}

export default function DetailSheet({
  open, dismiss, feature, legend,
}: DetailSheetProps) {
  const matchedLegend = legend.find((item) => item.color === feature?.color);
  const isCategorical = matchedLegend?.max === null && matchedLegend?.min === 0;

  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title={feature?.name ?? 'Detalhe'}
      className="mp-mobile-detail-sheet"
    >
      <div className="mp-mobile-detail-sheet-body">
        {matchedLegend && (
          <div className="mp-mobile-detail-sheet-row">
            <span
              className="mp-mobile-detail-sheet-swatch"
              style={{ backgroundColor: matchedLegend.color }}
            />
            <span className="mp-mobile-detail-sheet-label">
              {isCategorical
                ? matchedLegend.label
                : `${matchedLegend.label} (${matchedLegend.min}${matchedLegend.max !== null ? `–${matchedLegend.max}` : '+'})`}
            </span>
          </div>
        )}
        {!matchedLegend && (
          <p className="mp-mobile-detail-sheet-empty">Sem informações adicionais para esta região.</p>
        )}
      </div>
    </BottomSheet>
  );
}
